import { FactorMap, FactorKey } from "types/factor/factor";

import getPhoneNumber from "global-components/mfa/util/getPhoneNumber";

const hasActiveMatchingPhoneNumbers = (factorMap: FactorMap): boolean => {
  const smsFactor = factorMap[FactorKey.Sms];
  const callFactor = factorMap[FactorKey.Call];

  return (
    smsFactor.flags.isActive &&
    callFactor.flags.isActive &&
    getPhoneNumber(smsFactor) === getPhoneNumber(callFactor)
  );
};

export default hasActiveMatchingPhoneNumbers;
